
export interface Category {
    readonly id: string;
    readonly name: string;
    readonly type: CategoryType;
    readonly status: CategoryStatus;
    readonly position: number;
}

export enum CategoryType {
    All = 'all',
    Admin = 'admin',
    Customer = 'customer',
}

export enum CategoryStatus {
    All = 'ALL',
    PUBLISHED = 'PUBLISHED',
    HIDDEN = 'HIDDEN',
}

export const CategoryTypeOptions = [
    {
        text: 'Admin',
        value: CategoryType.Admin,
    },
    {
        text: 'Customer',
        value: CategoryType.Customer,
    },
]

export const categoryStatusOptions = [
    {
        text: 'All',
        value: CategoryStatus.All,
    },
    {
        text: 'Published',
        value: CategoryStatus.PUBLISHED,
    },
    {
        text: 'Hidden',
        value: CategoryStatus.HIDDEN,
    },
]